import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useAuth } from 'modules/Auth/Hooks';
import { useWidgets } from 'modules/Dashboard/Widgets/Hooks';
import { WidgetSettings } from 'modules/Dashboard/Widgets/Common';
import { UsersWidgetPlaceholder } from 'modules/Dashboard/Widgets/Users/Common';

import { ExamsInProgress as ExamsInProgressComponent } from './ExamsInProgress.component';
import { useExamsInProgressWidget } from './useExamsInProgressWidget';

export const ExamsInProgress = ({ widget, isMock }) => {
  const { isSuperAdmin, userDateFormat, userTimeFormat, userTimezone } =
    useAuth();
  const { state, refetch } = useExamsInProgressWidget({
    enabled: !!isSuperAdmin && !isMock,
  });
  const { saveWidgetSettings, removeActiveWidget } = useWidgets();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  if (!isSuperAdmin) return null;

  if (isSettingsOpen) {
    return (
      <WidgetSettings
        widget={widget}
        onSave={saveWidgetSettings}
        onClose={() => setIsSettingsOpen(false)}
        onRemoveWidget={removeActiveWidget}
      />
    );
  }

  if (!isMock && !state.loaded) {
    return <UsersWidgetPlaceholder widget={widget} />;
  }

  return (
    <ExamsInProgressComponent
      widget={widget}
      isMock={isMock}
      onOpenSettings={() => setIsSettingsOpen(true)}
      exams={isMock ? [] : state.exams}
      totalItems={isMock ? null : state.totalItems}
      generatedAt={state.generatedAt}
      loading={!isMock && state.loading}
      hasError={!!state.error}
      hasData={state.hasData}
      authFormat={{ userDateFormat, userTimeFormat, userTimezone }}
      onRefresh={refetch}
    />
  );
};

ExamsInProgress.propTypes = {
  widget: PropTypes.object,
  isMock: PropTypes.bool,
};
